import { mutator } from 'satcheljs';
import { default as setSelectedAccount } from '../actions/setSelectedAccount';
import getAccountSourceListStore from '../store/accountSourceListStore';

export default mutator(setSelectedAccount, actionMessage => {
    const store = getAccountSourceListStore();
    const found = store.sources.filter(source => source.sourceId == actionMessage.selectedSourceId);
    if (found.length > 0) {
        store.selectedSourceId = actionMessage.selectedSourceId;
    }
});
